import { api } from 'shared/api/common'

function getAppConfig () {
  return api.get('/api/v3/user_profiles/app_config/')
}

export {
  getAppConfig,
}
